import React from 'react';
import styled from 'styled-components';
import SFormSubtitle from 'shared/screens/LinkAccountForm/components/FormSubtitle';
import { getText, TEXT_KEY } from 'shared/utils/localization';
import { numberWithCommas } from 'shared/utils/number';

const DefaultFormSubtitle = () => {
  return (
    <SFormSubtitle
      render={args => {
        const { linkedLoyaltyCardBonus } = args;
        return (
          <LinkAccountFormSubTitle>
            {getText(TEXT_KEY.LINK_CARD_SUBTITLE)}
            <br />
            <LinkAccountBonusText>
              {getText(TEXT_KEY.EARN)} {numberWithCommas(linkedLoyaltyCardBonus.amount)}{' '}
              {linkedLoyaltyCardBonus.currency} {getText(TEXT_KEY.WHEN_YOU_LINK_YOUR_ACCOUNT)}
            </LinkAccountBonusText>
          </LinkAccountFormSubTitle>
        );
      }}
    />
  );
};

export default DefaultFormSubtitle;

const LinkAccountFormSubTitle = styled.p`
  text-align: center;
  ${({ theme }) =>
    theme.screens.device('mobile-browser') &&
    `
      margin: 0px;
    `}
`;

const LinkAccountBonusText = styled.span`
  font-weight: bold;
`;

